import moment from "moment";

export const dateFormatStringText = (date: Date) => {
  const fecha = moment(date);

  return fecha.format("dddd D [de] MMMM [del] YYYY");
};
